import {
  IonAlert,
  IonButton,
  IonContent,
  IonIcon,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonModal
} from "@ionic/react";
import { cartOutline, closeOutline } from "ionicons/icons";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { useCart } from "../../hooks/useCart";
import { t } from "../../translations";
import { shouldUseIonicComponents } from "../../utils/platformUtils";
import { FEATURE_FLAGS } from "../constants/featureFlags";

import "../styles/food-view.css";
import "../styles/section-food.css";

import { BsFillCartFill, BsPeopleFill, BsShareFill } from "react-icons/bs";
import { FaCheck, FaCopy } from "react-icons/fa";
import { getSafeOrigin } from "../../utils/capacitorSafety";

import "../styles/discover-our-chef.css";

import { useSelector } from "react-redux";
import { Aa } from "../functions/Aa";

import {
  Dialog,
  DialogActions,
  DialogContent,
  Rating,
  Typography
} from "@mui/material";
import user_icon from "../../assets/user-icon.png";
import Modal from "./modal";

const FoodView = (props) => {
  const history = useHistory();
  const [selected, setSelected] = useState("menu-chef");
  const [open, setOpen] = useState(false);
  const [openWaring, setOpenWarning] = useState(false);
  const [foodSelected, setFoodSelected] = useState(null);
  const [shareMenuFood, setShareMenuFood] = useState(false);
  const [, setFoodToShare] = useState(null);
  const [foodReferralLink, setFoodReferralLink] = useState("");
  const [copiedFood, setCopiedFood] = useState(false);
  const [displayedItems, setDisplayedItems] = useState(12);
  const useMobileUI = shouldUseIonicComponents();

  let cart = useSelector((state) => state.cart);
  let lang = useSelector((state) => state.lang);
  let user = useSelector((state) => state.user);
  let selectedChef = useSelector((state) => state.selectedChef);
  let selectedWhen = useSelector((state) => state.selectedWhen);

  const { foodList, reviewList, blogList } = props;

  // Use cart service
  const { toggleItem, hasChefConflict, clearCart } = useCart();

  // Handle infinite scroll
  const loadMoreItems = async (event) => {
    setTimeout(() => {
      setDisplayedItems((prev) => prev + 12);
      event?.target?.complete();
    }, 500);
  };

  // Get visible food items based on pagination
  const visibleFoodList =
    useMobileUI && foodList ? foodList.slice(0, displayedItems) : foodList;

  return (
    <div className="">
      <div
        className="menu-line"
        style={{
          width: "100%"
        }}
      >
        {[
          {
            key: "menu-chef",
            text: t("food_view.menu"),
            text_en: t("food_view.menu", lang)
          },
          {
            key: "comment-client",
            text: t("food_view.comments"),
            text_en: t("food_view.comments", lang)
          },
          {
            key: "blog-chef",
            text: t("food_view.blog"),
            text_en: t("food_view.blog", lang),
            featureFlag: "blogEnabled"
          }
        ]
          .filter(
            (item) => !item.featureFlag || FEATURE_FLAGS[item.featureFlag]
          )
          .map((item) => (
            <span
              className={selected === item.key ? "active" : ""}
              key={item.key}
              onClick={() => {
                setSelected(item.key);
              }}
            >
              {lang === "en" ? item?.text_en : item?.text}
            </span>
          ))}
      </div>

      {/* Here comes the food view complete*/}
      {selected === "menu-chef" && (
        <div className="food-view-block">
          {visibleFoodList?.map((item) => (
            <div
              className="food-view-card"
              onClick={() => {
                setFoodSelected(item);
                setOpen(true);
              }}
              style={{ cursor: "pointer" }}
            >
              <img
                alt="img-food"
                src={item?.pic}
                style={{
                  width: "100%",
                  objectFit: "cover",
                  borderBottomLeftRadius: 0,
                  borderBottomRightRadius: 0
                }}
              />
              <div
                className="food-view-card-text-block"
                style={{
                  height: 180
                }}
              >
                <h3>{item?.name}</h3>
                <span>{"$" + item?.cost}</span>
                <p
                  style={{
                    wordBreak: "break-word"
                  }}
                >
                  {item?.description?.length > 125
                    ? item?.description?.slice(0, 125) + "..."
                    : item?.description}
                </p>
              </div>
              <div className="food-view-card-text-btn">
                <span
                  style={{
                    backgroundColor: cart.filter((data) => {
                      return data._id === item._id;
                    })[0]
                      ? "#838383"
                      : "#ff114d"
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    // Check for chef conflict
                    if (hasChefConflict()) {
                      return setOpenWarning(true);
                    }

                    // Toggle item in cart
                    toggleItem(item);
                  }}
                >
                  <BsFillCartFill />
                  {cart.filter((data) => {
                    return data._id === item._id;
                  })[0]
                    ? t("food_view.remove_from_cart", lang)
                    : t("food_view.add_to_cart", lang)}
                </span>
                <p
                  className="food-view-card-special-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    setFoodSelected(item);
                    setOpen(true);
                  }}
                >
                  {t("food_view.see_details", lang)}
                </p>
                <p
                  className="food-view-card-share-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    // Generate food referral link
                    const userId = user?._id || "guest";
                    const chefId = selectedChef?._id || item?.chef_id;
                    const foodId = item?._id;
                    const baseUrl = getSafeOrigin();
                    const link = `${baseUrl}/order/chef/menu?chef=${chefId}&food=${foodId}&date=${selectedWhen}&ref=${userId}`;
                    setFoodReferralLink(link);
                    setFoodToShare(item);
                    setCopiedFood(false);
                    setShareMenuFood(true);
                  }}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px"
                  }}
                >
                  <BsShareFill size={14} />
                  {t("section_food_list.share", lang)}
                </p>
              </div>
            </div>
          ))}

          {/* Infinite scroll for mobile */}
          {useMobileUI &&
            visibleFoodList &&
            visibleFoodList.length < foodList?.length && (
              <IonInfiniteScroll
                onIonInfinite={loadMoreItems}
                threshold="100px"
              >
                <IonInfiniteScrollContent
                  loadingSpinner="bubbles"
                  loadingText={
                    t("common.loading_more", lang) || "Loading more..."
                  }
                />
              </IonInfiniteScroll>
            )}
        </div>
      )}

      {selected === "comment-client" && (
        <div className="food-view-block">
          {!reviewList || reviewList.length === 0 ? (
            <p
              style={{
                color: "#000",
                fontSize: 19,
                textAlign: "center"
              }}
            >
              {t("food_view.no_review_yet", lang)}
            </p>
          ) : (
            reviewList?.map((item) => (
              <div
                style={{
                  width: "100%",
                  borderBottom: "1px solid #d9d9d9",
                  minHeight: 100,
                  alignItems: "center",
                  padding: 10,
                  display: "flex"
                }}
              >
                <div
                  style={{
                    width: 10,
                    height: 100,
                    backgroundColor: "#ff114d"
                  }}
                ></div>
                <div
                  style={{
                    marginLeft: 10
                  }}
                >
                  <p
                    style={{
                      fontSize: 15,
                      textAlign: "left",
                      display: "flex",
                      gap: 5
                    }}
                  >
                    <img
                      src={user_icon}
                      alt="user-icon"
                      style={{
                        width: 25,
                        height: 25
                      }}
                    />
                    {item?.user_id?.firstname === "" &&
                      t("profile.pani_user", lang)}
                    {item?.user_id?.firstname !== "" &&
                      Aa(
                        item?.user_id?.firstname + " " + item?.user_id?.lastname
                      )}
                    <Rating
                      value={item?.rate_food?.rate}
                      readOnly
                      precision={1}
                      style={{}}
                    />
                  </p>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexWrap: "wrap"
                    }}
                  >
                    <div style={{}}>
                      <p
                        style={{
                          fontSize: 15,
                          marginLeft: 5
                        }}
                      >
                        {item?.rate_food?.text}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      )}

      {selected === "blog-chef" && (
        <div className="food-view-block">
          {!blogList || blogList.length === 0 ? (
            <p
              style={{
                color: "#000",
                fontSize: 19,
                textAlign: "center"
              }}
            >
              {t("food_view.no_article_yet", lang)}
            </p>
          ) : (
            blogList?.map((item) => (
              <div
                className="blog-item"
                style={{
                  width: "100%",
                  borderRadius: 10,
                  border: "1px solid #d9d9d9",
                  minHeight: 100,
                  alignItems: "center",
                  display: "flex"
                }}
                onClick={() => {
                  return history.push(
                    `/blog?chef=${item.chef_id}&article=${item?._id}`
                  );
                }}
              >
                <img
                  src={item?.pic}
                  style={{
                    width: 150,
                    height: "100%",
                    borderRadius: 0,
                    borderTopRightRadius: 0,
                    borderBottomLeftRadius: 15,
                    borderBottomRightRadius: 0,
                    borderRight: "1px solid #d9d9d9"
                  }}
                  alt="blog-img"
                />
                <div>
                  <p
                    style={{
                      width: "95%",
                      fontSize: 16,
                      fontWeight: 600,
                      textAlign: "left",
                      gap: 5,
                      marginLeft: 10,
                      marginTop: 0,
                      wordBreak: "break-word"
                    }}
                  >
                    {Aa(item?.title?.slice(0, 80))}
                  </p>
                  <p
                    style={{
                      width: "95%",
                      fontSize: 15,
                      textAlign: "left",
                      marginLeft: 10,
                      marginTop: 20,
                      wordBreak: "break-word"
                    }}
                  >
                    {item?.message?.slice(0, 250) + "..."}
                  </p>
                </div>
              </div>
            ))
          )}
        </div>
      )}

      {/* Cart Warning - Ionic Alert for mobile, MUI Dialog for web */}
      {useMobileUI ? (
        <IonAlert
          isOpen={openWaring}
          onDidDismiss={() => setOpenWarning(false)}
          header={t("food_view.clear_cart_warning", lang)}
          buttons={[
            {
              text: t("food_view.no", lang),
              role: "cancel"
            },
            {
              text: t("food_view.yes", lang),
              handler: () => {
                clearCart();
              }
            }
          ]}
        />
      ) : (
        <Dialog
          open={openWaring}
          onClose={() => {
            setOpenWarning(false);
          }}
        >
          <DialogContent>
            <Typography>{t("food_view.clear_cart_warning", lang)}</Typography>
          </DialogContent>
          <DialogActions>
            <div
              className="btn-get-started"
              style={{
                width: 80,
                fontWeight: "600"
              }}
              onClick={() => {
                clearCart();
                return setOpenWarning(false);
              }}
            >
              {t("food_view.yes", lang)}
            </div>
            <div
              className="btn-get-started"
              style={{
                width: 80,
                backgroundColor: "#fff",
                color: "#000",
                fontWeight: "600"
              }}
              onClick={() => {
                return setOpenWarning(false);
              }}
            >
              {t("food_view.no", lang)}
            </div>
          </DialogActions>
        </Dialog>
      )}

      {/* Food Detail - Ionic Modal for mobile, custom Modal for web */}
      {useMobileUI ? (
        <IonModal
          isOpen={open}
          onDidDismiss={() => {
            setFoodSelected(null);
            setOpen(false);
          }}
          initialBreakpoint={0.75}
          breakpoints={[0, 0.75]}
          style={{
            "--border-radius": "16px 16px 0 0"
          }}
        >
          <IonContent scrollY={false}>
            <div style={{ position: "relative" }}>
              {/* Close button overlaid on image */}
              <div
                onClick={() => {
                  setFoodSelected(null);
                  setOpen(false);
                }}
                style={{
                  position: "absolute",
                  top: 10,
                  right: 10,
                  zIndex: 10,
                  backgroundColor: "rgba(0,0,0,0.5)",
                  color: "#fff",
                  borderRadius: "50%",
                  width: 32,
                  height: 32,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  backdropFilter: "blur(4px)"
                }}
              >
                <IonIcon icon={closeOutline} style={{ fontSize: 20 }} />
              </div>

              {/* Image */}
              <img
                alt="img-food"
                src={foodSelected?.pic}
                style={{
                  width: "100%",
                  height: 180,
                  objectFit: "cover",
                  display: "block"
                }}
              />

              {/* Content */}
              <div style={{ padding: "10px 14px" }}>
                {/* Name + Price */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}
                >
                  <h2
                    style={{ fontSize: 16, fontWeight: 600, margin: 0, flex: 1 }}
                  >
                    {Aa(foodSelected?.name)}
                  </h2>
                  <span
                    style={{
                      backgroundColor: "#ff114d",
                      color: "#fff",
                      borderRadius: 20,
                      padding: "3px 10px",
                      fontSize: 13,
                      fontWeight: 600,
                      whiteSpace: "nowrap"
                    }}
                  >
                    {"$" + foodSelected?.cost}
                  </span>
                </div>

                {/* Chips row */}
                <div
                  style={{
                    display: "flex",
                    gap: 4,
                    flexWrap: "wrap",
                    marginTop: 6
                  }}
                >
                  {foodSelected?.spice_level && (
                    <span
                      style={{
                        backgroundColor: "#FFFD92",
                        color: "#000",
                        borderRadius: 8,
                        padding: "2px 8px",
                        fontSize: 11
                      }}
                    >
                      {lang === "fr"
                        ? foodSelected?.spice_level?.name
                        : foodSelected?.spice_level?.eng_name}
                    </span>
                  )}
                  {foodSelected?.food_type && (
                    <span
                      style={{
                        backgroundColor: "#e8f5e9",
                        color: "#2e7d32",
                        borderRadius: 8,
                        padding: "2px 8px",
                        fontSize: 11
                      }}
                    >
                      {lang === "fr"
                        ? foodSelected?.food_type?.name
                        : foodSelected?.food_type?.eng_name}
                    </span>
                  )}
                  <span
                    style={{
                      color: "#555",
                      fontSize: 11,
                      display: "flex",
                      alignItems: "center",
                      gap: 3
                    }}
                  >
                    <BsPeopleFill size={10} /> {foodSelected?.portion}{" "}
                    {t("food_view.persons", lang)}
                  </span>
                  {foodSelected?.expirity && (
                    <span style={{ color: "#555", fontSize: 11 }}>
                      {foodSelected?.expirity} {t("food_view.days", lang)}
                    </span>
                  )}
                </div>

                {/* Description - truncated */}
                <p
                  style={{
                    margin: "8px 0 0",
                    color: "#555",
                    fontSize: 13,
                    lineHeight: 1.4,
                    overflow: "hidden",
                    display: "-webkit-box",
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: "vertical"
                  }}
                >
                  {foodSelected?.description}
                </p>

                {/* Ingredients inline */}
                {foodSelected?.ingredient &&
                  foodSelected?.ingredient.length > 0 && (
                    <p style={{ margin: "6px 0 0", fontSize: 12, color: "#777" }}>
                      <strong>{t("food_view.ingredients", lang)}:</strong>{" "}
                      {foodSelected?.ingredient
                        ?.map((e) => Aa(lang === "en" ? e?.eng_name : e?.name))
                        .join(", ")}
                    </p>
                  )}

                {/* Allergens inline */}
                {foodSelected?.allergens &&
                  (Array.isArray(foodSelected?.allergens)
                    ? foodSelected?.allergens.length > 0
                    : true) && (
                    <p
                      style={{
                        margin: "4px 0 0",
                        fontSize: 12,
                        color: "#c62828"
                      }}
                    >
                      <strong>{t("food_view.allergies", lang)}:</strong>{" "}
                      {Array.isArray(foodSelected?.allergens)
                        ? foodSelected?.allergens
                            ?.map((e) =>
                              Aa(lang === "en" ? e?.eng_name : e?.name)
                            )
                            .join(", ")
                        : lang === "fr"
                          ? foodSelected?.allergens?.name
                          : foodSelected?.allergens?.eng_name}
                    </p>
                  )}

                {/* Cart button */}
                <IonButton
                  expand="block"
                  size="small"
                  style={{
                    marginTop: 10,
                    marginBottom: 4,
                    "--background": cart?.filter(
                      (d) => d._id === foodSelected?._id
                    )[0]
                      ? "#838383"
                      : "#ff114d"
                  }}
                  onClick={() => {
                    if (hasChefConflict()) return setOpenWarning(true);
                    toggleItem(foodSelected);
                  }}
                >
                  <IonIcon icon={cartOutline} slot="start" />
                  {cart.filter((d) => d._id === foodSelected?._id)[0]
                    ? t("food_view.remove_from_cart", lang)
                    : t("food_view.add_to_cart", lang)}
                </IonButton>
              </div>
            </div>
          </IonContent>
        </IonModal>
      ) : (
        <Modal
          isOpen={open}
          onClose={() => {
            setFoodSelected(null);
            setOpen(false);
          }}
          Content={() => {
            return (
              <div style={{ width: "100%", height: "100%" }}>
                <div style={{ width: "100%" }}>
                  <img
                    alt="img-food"
                    src={foodSelected?.pic}
                    style={{
                      width: "100%",
                      objectFit: "cover",
                      borderRadius: 0
                    }}
                  />
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginTop: 10,
                      flexWrap: "wrap",
                      width: "100%",
                      textAlign: "left"
                    }}
                  >
                    <h3 style={{ width: "70%" }}>{Aa(foodSelected?.name)}</h3>
                    <span
                      style={{
                        padding: 10,
                        backgroundColor: "#ff114d",
                        color: "#fff",
                        borderRadius: 40,
                        width: 80,
                        height: 40,
                        textAlign: "center"
                      }}
                    >
                      {"$" + foodSelected?.cost}
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: 8,
                      flexWrap: "wrap",
                      marginTop: 10
                    }}
                  >
                    {foodSelected?.spice_level && (
                      <div
                        style={{
                          padding: "5px 10px",
                          backgroundColor: "#FFFD92",
                          color: "#000",
                          borderRadius: 10,
                          fontSize: 12,
                          textAlign: "center"
                        }}
                      >
                        {lang === "fr"
                          ? foodSelected?.spice_level?.name
                          : foodSelected?.spice_level?.eng_name}
                      </div>
                    )}
                    {foodSelected?.food_type && (
                      <div
                        style={{
                          padding: "5px 10px",
                          backgroundColor: "#e8f5e9",
                          color: "#2e7d32",
                          borderRadius: 10,
                          fontSize: 12,
                          textAlign: "center"
                        }}
                      >
                        {lang === "fr"
                          ? foodSelected?.food_type?.name
                          : foodSelected?.food_type?.eng_name}
                      </div>
                    )}
                    {foodSelected?.package && (
                      <div
                        style={{
                          padding: "5px 10px",
                          backgroundColor: "#e3f2fd",
                          color: "#1565c0",
                          borderRadius: 10,
                          fontSize: 12,
                          textAlign: "center"
                        }}
                      >
                        {t(`food_view.${foodSelected?.package}`, lang)}
                      </div>
                    )}
                  </div>
                  <div
                    style={{
                      width: "100%",
                      marginTop: 15,
                      textAlign: "left",
                      fontSize: 12
                    }}
                  >
                    <h4 style={{ fontWeight: 500 }}>
                      {t("food_view.portion", lang)}
                    </h4>
                    <span
                      style={{ display: "flex", alignItems: "center", gap: 5 }}
                    >
                      <BsPeopleFill /> {foodSelected?.portion}{" "}
                      {t("food_view.persons", lang)}
                    </span>
                    {foodSelected?.expirity && (
                      <>
                        <h4 style={{ fontWeight: 500, marginTop: 10 }}>
                          {t("food_view.expiry", lang)}
                        </h4>
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 5
                          }}
                        >
                          {foodSelected?.expirity} {t("food_view.days", lang)}
                        </span>
                      </>
                    )}
                    <h4 style={{ fontWeight: 500, marginTop: 10 }}>
                      {t("food_view.description", lang)}
                    </h4>
                    <span
                      style={{ display: "flex", alignItems: "center", gap: 5 }}
                    >
                      {foodSelected?.description}
                    </span>
                    {foodSelected?.ingredient &&
                      foodSelected?.ingredient.length > 0 && (
                        <>
                          <h4 style={{ fontWeight: 500, marginTop: 10 }}>
                            {t("food_view.ingredients", lang)}
                          </h4>
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 5
                            }}
                          >
                            {foodSelected?.ingredient
                              ?.map((e) =>
                                Aa(lang === "en" ? e?.eng_name : e?.name)
                              )
                              .join(", ")}
                          </span>
                        </>
                      )}
                    {foodSelected?.allergens && (
                      <>
                        <h4 style={{ fontWeight: 500, marginTop: 10 }}>
                          {t("food_view.allergies", lang)}
                        </h4>
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 5
                          }}
                        >
                          {Array.isArray(foodSelected?.allergens)
                            ? foodSelected?.allergens
                                ?.map((e) =>
                                  Aa(lang === "en" ? e?.eng_name : e?.name)
                                )
                                .join(", ")
                            : lang === "fr"
                              ? foodSelected?.allergens?.name
                              : foodSelected?.allergens?.eng_name}
                        </span>
                      </>
                    )}
                    {foodSelected?.geographical_tag &&
                      foodSelected?.geographical_tag.length > 0 && (
                        <>
                          <h4 style={{ fontWeight: 500, marginTop: 10 }}>
                            {t("food_view.geographical_tags", lang)}
                          </h4>
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 5,
                              flexWrap: "wrap"
                            }}
                          >
                            {foodSelected?.geographical_tag
                              ?.map((e) =>
                                Aa(lang === "en" ? e?.eng_name : e?.name)
                              )
                              .join(", ")}
                          </span>
                        </>
                      )}
                    {foodSelected?.speciality_tag &&
                      foodSelected?.speciality_tag.length > 0 && (
                        <>
                          <h4 style={{ fontWeight: 500, marginTop: 10 }}>
                            {t("food_view.speciality_tags", lang)}
                          </h4>
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 5,
                              flexWrap: "wrap"
                            }}
                          >
                            {foodSelected?.speciality_tag
                              ?.map((e) =>
                                Aa(lang === "en" ? e?.eng_name : e?.name)
                              )
                              .join(", ")}
                          </span>
                        </>
                      )}
                    {foodSelected?.comment && (
                      <>
                        <h4 style={{ fontWeight: 500, marginTop: 10 }}>
                          {t("food_view.comment", lang)}
                        </h4>
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 5
                          }}
                        >
                          {foodSelected?.comment}
                        </span>
                      </>
                    )}
                    {foodSelected?.extra_food && (
                      <>
                        <h4 style={{ fontWeight: 500, marginTop: 10 }}>
                          {t("food_view.extra_food", lang)}
                        </h4>
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 5
                          }}
                        >
                          {foodSelected?.extra_food}
                        </span>
                      </>
                    )}
                  </div>
                  <span
                    className="special-add-to-cart-btn"
                    style={{
                      backgroundColor: cart?.filter(
                        (d) => d._id === foodSelected?._id
                      )[0]
                        ? "#838383"
                        : "#ff114d",
                      width: "100%",
                      marginTop: 10
                    }}
                    onClick={() => {
                      if (hasChefConflict()) return setOpenWarning(true);
                      toggleItem(foodSelected);
                    }}
                  >
                    <BsFillCartFill />
                    {cart.filter((d) => d._id === foodSelected?._id)[0]
                      ? t("food_view.remove_from_cart", lang)
                      : t("food_view.add_to_cart", lang)}
                  </span>
                </div>
              </div>
            );
          }}
          styleOverlay={{}}
          styleContent={{ minWidth: 250, maxWidth: 700 }}
          styleClose={{}}
        />
      )}

      {/* Food Share - Ionic Modal for mobile, MUI Dialog for web */}
      {useMobileUI ? (
        <IonModal
          isOpen={shareMenuFood}
          onDidDismiss={() => setShareMenuFood(false)}
          initialBreakpoint={0.85}
          breakpoints={[0, 0.85]}
          style={{ "--width": "85%", "--height": "85%" }}
        >
          <IonContent className="ion-padding">
            <h3 style={{ fontWeight: 600, marginTop: 10 }}>
              {t("common.sharing", lang)}
            </h3>
            <p style={{ fontSize: 14, color: "#555" }}>
              {t("common.share_food_desc", lang) ||
                "Share this delicious dish with your friends!"}
            </p>
            <div
              style={{
                backgroundColor: "#f5f5f5",
                padding: 12,
                borderRadius: 8,
                display: "flex",
                alignItems: "center",
                gap: 8,
                marginTop: 12
              }}
            >
              <input
                type="text"
                value={foodReferralLink}
                readOnly
                style={{
                  flex: 1,
                  border: "none",
                  background: "transparent",
                  outline: "none",
                  fontSize: 13,
                  color: "#333"
                }}
              />
              <IonButton
                size="small"
                color={copiedFood ? "success" : "primary"}
                onClick={() => {
                  navigator.clipboard.writeText(foodReferralLink);
                  setCopiedFood(true);
                  setTimeout(() => setCopiedFood(false), 2000);
                }}
              >
                {copiedFood ? <FaCheck /> : <FaCopy />}
                <span style={{ marginLeft: 4 }}>
                  {copiedFood
                    ? t("common.copied", lang) || "Copied!"
                    : t("common.copy", lang) || "Copy"}
                </span>
              </IonButton>
            </div>
            <p style={{ fontSize: 12, color: "#888", marginTop: 10 }}>
              {t("common.share_link_description", lang) ||
                "Share this link with your friends to help them discover this amazing dish!"}
            </p>
          </IonContent>
        </IonModal>
      ) : (
        <Dialog
          open={shareMenuFood}
          onClose={() => {
            setShareMenuFood(false);
          }}
        >
          <DialogContent>
            <div style={{ minWidth: 300, height: "100%" }}>
              <div>
                <p
                  style={{
                    textAlign: "left",
                    display: "flex",
                    alignItems: "center",
                    gap: 15,
                    fontWeight: 600,
                    marginTop: 30,
                    fontSize: 17
                  }}
                >
                  {t("common.sharing", lang)}
                </p>
                <p
                  style={{ textAlign: "left", fontSize: 15, marginBottom: 20 }}
                >
                  {t("common.share_food_desc", lang) ||
                    "Share this delicious dish with your friends!"}
                </p>
                <div
                  style={{
                    backgroundColor: "#f5f5f5",
                    padding: "15px",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    marginBottom: "20px"
                  }}
                >
                  <input
                    type="text"
                    value={foodReferralLink}
                    readOnly
                    style={{
                      flex: 1,
                      border: "none",
                      background: "transparent",
                      outline: "none",
                      fontSize: "14px",
                      color: "#333"
                    }}
                  />
                  <button
                    onClick={() => {
                      navigator.clipboard.writeText(foodReferralLink);
                      setCopiedFood(true);
                      setTimeout(() => setCopiedFood(false), 2000);
                    }}
                    style={{
                      background: copiedFood ? "#4CAF50" : "#007bff",
                      color: "white",
                      border: "none",
                      borderRadius: "5px",
                      padding: "10px 20px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      fontSize: "14px",
                      fontWeight: "600",
                      transition: "all 0.3s ease"
                    }}
                  >
                    {copiedFood ? <FaCheck /> : <FaCopy />}
                    {copiedFood
                      ? t("common.copied", lang) || "Copied!"
                      : t("common.copy", lang) || "Copy"}
                  </button>
                </div>
                <p
                  style={{
                    textAlign: "left",
                    fontSize: 13,
                    color: "#666",
                    marginTop: "10px"
                  }}
                >
                  {t("common.share_link_description", lang) ||
                    "Share this link with your friends to help them discover this amazing dish!"}
                </p>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
};

export default FoodView;
